import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from '../../contexts/AuthContext';
import "./Login.css";
import Swal from "sweetalert2";
import axios from "axios";

const Signup = function () {
  const { user } = useContext(AuthContext);
  const URL_SIGNUP = import.meta.env.VITE_URL_USERS;
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
  }, []);

  const handleForm = (event) => {
    event.preventDefault();
    axios
      .post(
        URL_SIGNUP,
        {
          nombre: firstName,
          email,
          password,
          tipo: "Cliente",
          dashboard: true
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        clear();
        Swal.fire("Good job!", "Creado con éxito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
  };

  const clear = () => {
    setFirstName("");
    setEmail("");
    setPassword("");
  };

  return (
    <div className="login-page">
      <div className="login-card">
        {/* Logo */}
        <div className="login-logo-container">
          <img
            src="/Logo-Sistemify-Login.png"
            alt="GridBot Trading Platform"
            className="login-logo"
          />
        </div>

        {/* Title */}
        <h1 className="login-title">Registro de Usuario</h1>
        <p className="login-subtitle">Crea una nueva cuenta en el sistema</p>

        {/* Form */}
        <form className="login-form" onSubmit={handleForm}>
          {/* Name Input */}
          <div className="login-form-group">
            <label htmlFor="firstName" className="login-label">
              Nombre
            </label>
            <input
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              type="text"
              id="firstName"
              placeholder="Ingresa el nombre"
              className="login-input"
              required
            />
          </div>

          {/* Email Input */}
          <div className="login-form-group">
            <label htmlFor="email" className="login-label">
              Email
            </label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              id="email"
              placeholder="usuario@email.com"
              className="login-input"
              required
            />
          </div>

          {/* Password Input */}
          <div className="login-form-group">
            <label htmlFor="password" className="login-label">
              Contraseña
            </label>
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              id="password"
              placeholder="Ingresa la contraseña"
              className="login-input"
              required
            />
          </div>

          {/* Submit Button */}
          <button 
            type="submit" 
            className="login-button"
            disabled={!user?.usuarios_create}
          >
            Dar de Alta
          </button>
        </form>

        {/* Footer Links */}
        <div className="login-footer">
          <a href="/login" className="login-footer-link">
            ¿Ya tienes cuenta? Inicia sesión aquí
          </a>
        </div>
      </div>
    </div>
  );
};

export default Signup;
